import { createEmitter } from "../emitter.ts";
import { ApiResponseError } from "./error/api-response-error.ts";
import type { HttpVerbs } from "./types.ts";

export const { emit: emitError, onEvent: onError } = createEmitter<unknown>();

export async function parseResponse<T>(
  response: Response,
  requestedMethod: HttpVerbs,
  requestedUrl: string,
): Promise<T> {
  const responseBody = await parseResponseBody<T>(response);

  if (!response.ok) {
    throw new ApiResponseError({
      httpStatusCode: response.status,
      requestedMethod,
      correlationId: response.headers.get("x-correlation-id"),
      requestedUrl: response.url || requestedUrl,
      data: responseBody,
      type: response.type,
    });
  } else {
    return responseBody;
  }
}

export async function parseResponseBody<T = unknown>(
  response: Response,
): Promise<T> {
  const kivraObjKey = response.headers.get("kivra-objkey");
  const contentType = response.headers
    .get("content-type")
    ?.toLowerCase()
    .split(";")[0];

  if (!contentType) {
    return undefined as any;
  }

  switch (contentType) {
    case "application/json": {
      const result = await response.json();
      return kivraObjKey ? Object.assign(result, { kivraObjKey }) : result;
    }
    case "text/plain":
    case "text/html":
      return response.text() as any;
    default:
      return response.arrayBuffer() as any;
  }
}

export function createAccessTokenHeader(
  accessToken?: string,
): Record<string, string> | undefined {
  if (accessToken) {
    return {
      Authorization: `token ${accessToken}`,
    };
  }
  return undefined;
}
